import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Navigation.css';

const Navigation = () => {
  const { user, logout, isAdmin } = useAuth();
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  const handleLogout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      logout();
    }
  };

  return (
    <nav className="navigation">
      <div className="nav-container">
        {/* Logo/Brand */}
        <div className="nav-brand">
          <Link to="/dashboard" className="logo">
            <span className="logo-text">Green Hill Metrics</span>
          </Link>
        </div>

        {/* Main Navigation Links */}
        <div className="nav-links">
          <Link 
            to="/dashboard" 
            className={`nav-link ${isActive('/dashboard')}`}
          >
            Dashboard
          </Link>
          <Link 
            to="/donors" 
            className={`nav-link ${isActive('/donors')}`}
          >
            Donors
          </Link>
          <Link 
            to="/grants" 
            className={`nav-link ${isActive('/grants')}`}
          >
            Grants
          </Link>
          <Link 
            to="/organizations" 
            className={`nav-link ${isActive('/organizations')}`}
          >
            Organizations
          </Link>
          <Link 
            to="/reports" 
            className={`nav-link ${isActive('/reports')}`}
          >
            Reports
          </Link>

          {/* Admin Link - Only show if user is admin */}
          {user && isAdmin && (
            <Link 
              to="/admin" 
              className={`nav-link admin-link ${isActive('/admin')}`}
              title="Admin Dashboard"
            >
              Admin
            </Link>
          )}
        </div>

        {/* Right Side - User Info & Logout */}
        <div className="nav-right">
          <div className="user-info">
            <span className="user-name">
              {user?.first_name} {user?.last_name}
            </span>
            {isAdmin && (
              <span className="admin-badge">Admin</span>
            )}
          </div>
          <button 
            className="logout-btn"
            onClick={handleLogout}
            title="Logout"
          >
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
